/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Checkbox, Heading, HFlow, Modal, ModalBody, ModalFooter, Text, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { FooterButton } from 'components/footer-button'
import { RequiredLabel } from 'components/form/final-form/RequiredLabel/RequiredLabel'
import { useState } from 'react'

interface SistemasExternosTermoModalProps {
  isOpen: boolean
  onClose: () => void
  onAccept: () => void
}

export function SistemasExternosTermoModal(props: Readonly<SistemasExternosTermoModalProps>) {
  const { isOpen, onClose, onAccept } = props
  const [isTermoAceito, setIsTermoAceito] = useState(false)

  const handleConfirm = () => {
    if (isTermoAceito) {
      onAccept()
      setIsTermoAceito(false)
    }
  }

  return (
    <Modal
      open={isOpen}
      size='small'
      hasCloseIcon={true}
      closeOnBackdropClick={false}
      onClose={onClose}
      style={{ minWidth: '43.75rem' }}
    >
      <ModalBody>
        <VFlow vSpacing={1}>
          <Heading level={1}>TERMO DE RESPONSABILIDADE PARA INTEGRAÇÃO DE SISTEMA EXTERNO</Heading>
          <Heading level={3}>Disposições Gerais</Heading>
          <Text>
            O presente termo regula as condições para a integração do Sistema Integrado ao Prontuário Eletrônico do
            Cidadão (PEC), integrante da estratégia e-SUS Atenção Primária à Saúde (APS), do Ministério da Saúde, aqui
            denominado Sistema Integrador, consistindo exclusivamente na abertura de uma interface externa (iframe,
            pop-up ou mecanismo equivalente) para visualização e interação direta no Sistema Integrado, sem troca ativa
            de dados entre os sistemas, exceto o envio de CPF e/ou CNS para identificação no Sistema Integrado.
          </Text>
          <Heading level={3}>Restrição de Escopo e Localidade dos Dados</Heading>
          <Text>
            Os dados transmitidos pelo Sistema Integrador ao Sistema Integrado (CPF e/ou CNS) não serão encaminhados,
            replicados ou transmitidos a qualquer sistema centralizador nacional, incluindo plataformas estaduais ou
            federais. O tratamento e armazenamento desses dados devem permanecer restritos à base local do município
            responsável pela integração, não podendo ser utilizados para fins distintos dos informados neste termo, nem
            compartilhados com terceiros sem o devido fundamento legal e consentimento, quando necessário.
          </Text>
          <Heading level={3}>Responsabilidade</Heading>
          <Text>
            O Sistema Integrador não se responsabiliza: Pela disponibilidade, integridade, veracidade ou segurança das
            informações exibidas no Sistema Integrado. Por falhas, indisponibilidades, incidentes ou qualquer dano
            causado em decorrência do uso do Sistema Integrado.
          </Text>
          <Text>
            Para maiores informações sobre o Prontuário Eletrônico do Cidadão (PEC), integrante da estratégia e-SUS
            Atenção Primária à Saúde (APS), do Ministério da Saúde consultar os Termos de Uso e Privacidade, aqui.
          </Text>
          <Box>
            <Checkbox
              onChange={() => setIsTermoAceito(!isTermoAceito)}
              autoFocus
              checked={isTermoAceito}
              label={<RequiredLabel inline fontWeight='bold' label='Aceito o termo de responsabilidade' />}
            />
          </Box>
        </VFlow>
      </ModalBody>
      <ModalFooter>
        <HFlow justifyContent='flex-end' hSpacing={1}>
          <FooterButton kind='primary' onClick={handleConfirm} disabled={!isTermoAceito}>
            Cadastrar sistema
          </FooterButton>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}
